<div class="ops-switch-container">
  <div class="option" [class.selected]="isAnnual()" (click)="select('annual')">
    {{ 'subscription.annual' | translate }}
  </div>
  <div
    class="option"
    [class.selected]="isMonthly()"
    (click)="select('monthly')"
  >
    {{ 'subscription.monthly' | translate }}
  </div>
  <div class="slider" [class.annual]="isMonthly()"></div>
</div>
